// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps } from '@mui/material';
import Svg from '@rhg/../public/_n/images/icons/checkmarkcircle-empty.svg';

export const CheckmarkCircleEmpty = (props: SvgIconProps) => (
    <SvgIcon component={Svg} inheritViewBox {...props} />
);
